declare let ga: any

// @ts-ignore
import * as QueryParams from '@waze/george/lib/query-params'
// @ts-ignore
import * as Browser from '@waze/george/lib/browser'

let trackersNames: Array<string | undefined> = [undefined]

export function report(
  eventCategory: string,
  eventAction: string,
  eventLabel?: string,
  eventValue?: number,
  nonInteractive = false
): Promise<void> {
  if (QueryParams.has('ga_debug')) {
    console.info('GA', { eventCategory, eventAction, eventLabel, eventValue })
  }

  return new Promise(resolve => {
    for (let i = 0; i < trackersNames.length; ++i) {
      // When multiple trackers are used, we'll resolve the promise only
      // after the last event was sent.
      const hitCallback = i === trackersNames.length - 1 ? () => resolve() : undefined
      ga(getCommand('send', trackersNames[i]), 'event', {
        eventCategory,
        eventAction,
        eventLabel,
        eventValue,
        nonInteraction: nonInteractive,
        hitCallback
      })
    }
  })
}

export function pageView(pageUrl: string) {
  for (const trackerName of trackersNames) {
    ga(getCommand('set', trackerName), 'page', pageUrl)
    ga(getCommand('send', trackerName), 'pageview')
  }
}

export function reportAndNavigateTo(
  href: string,
  eventCategory: string,
  eventAction: string,
  eventLabel?: string
): Promise<void> {
  return report(eventCategory, eventAction, eventLabel).then(() => Browser.navigateTo(href))
}

export function userTiming(category: string, variable: string, value: number) {
  for (const trackerName of trackersNames) {
    ga(getCommand('send', trackerName), 'timing', category, variable, value)
  }
}

/**
 * Adds additional (named) trackers, to allow reporting GA
 * statistics to multiple properties.
 * See: http://go/ga-multiple-trackers
 */
export function addTracker(webProperty: string, trackerName: string, options?: any) {
  trackersNames.push(trackerName)
  ga('create', webProperty, 'auto', trackerName, options)
  ga(getCommand('send', trackerName), 'pageview')
}

export function resetTrackers() {
  trackersNames = [undefined]
}

/**
 * Create a ga command, including a possible tracker name.
 * Required to support multiple trackers on a single page.
 * See: http://go/ga-multi-trackers-adding-commands
 */
function getCommand(methodName: string, trackerName?: string) {
  return trackerName ? `${trackerName}.${methodName}` : methodName
}
